export default __webpack_public_path__ + "static/media/artboard.482a1f2f.png";